import React, { useCallback } from 'react'
import { debounce } from 'lodash'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'

// Components
import { Text, If, Unless, BotHeadSpin, FormField } from 'src/Components'

// Utils
import { dispatchEvent } from 'src/helpers/tagManager'
import { SignUpStarted } from 'src/constants/trackingEvents'

// Context
import { useSignUpProvider } from '../SignUpContext'

// Styles
import styles from './Email.module.scss'

const ERRORS = {
  default: defineMessages({
    email: {
      id: 'NewBuyerSignUp.emailStep.inputError',
      defaultMessage: 'Double check for any typos in your email address',
    },
  }),
}

const Error = props => <Text size='s' variant='danger' {...props} />

const Email = () => {
  const intl = useIntl()
  const {
    loading,
    handleOnChange,
    inputError,
    formState: { email },
  } = useSignUpProvider()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedEmailTrack = useCallback(
    debounce(() => {
      dispatchEvent(SignUpStarted)
    }, 5000),
    []
  )

  const trackEmailFocus = useCallback(() => {
    debouncedEmailTrack()
  }, [debouncedEmailTrack])

  return (
    <>
      <Unless condition={loading}>
        <div className={styles.emailStep}>
          <Text
            weight='light'
            size='xl'
            variant='neutralCool'
            variantCount='900'
            className={styles.headline}
          >
            <FormattedMessage
              id='NewBuyerSignUp.emailStep.salutation'
              defaultMessage='Hi, Guest!'
            />
          </Text>
          <Text size='s' variant='neutralCool' variantCount='700'>
            <FormattedMessage
              id='NewBuyerSignUp.emailStep.helper'
              defaultMessage='To get things started, enter your email:'
            />
          </Text>
          <FormField.Email
            value={email}
            captionMessage={
              inputError ? intl.formatMessage(ERRORS.default.email) : ''
            }
            captionText={Error}
            className={styles.form}
            onChange={handleOnChange}
            onFocus={trackEmailFocus}
          />
        </div>
      </Unless>
      <If condition={loading}>
        <BotHeadSpin panelSpacing />
      </If>
    </>
  )
}

export default Email
